import ApiService from '../api.service'

const PubSiteAdminService = {
    async getPublicSiteStatus (payload) {
        // console.log(store)
        const url = `/api/PublicSiteAdmin/GetPublicSiteStatus`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },
    async unlockPublicSite (payload) {
        // console.log(store)
        const url = `/api/PublicSiteAdmin/UnlockPublicSite`
        const requestData = {
            method: 'post',
            url: url,
            data: payload,
        }

        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        } catch (ex) {
            throw ex
        }

    },

}

export default PubSiteAdminService